<molecule-input-search
    [formInputData]="formInputData"
    [autoFocus]="autoFocus"
    (valueChanged)="onSearch($event)"
></molecule-input-search>
